<template>
  <div class="error-page-container">
    <big-title> {{ mainTitle }} </big-title>
    <button-main @click="logout()">
      {{ btnText }}
    </button-main>
  </div>
</template>

<script>
import BigTitle from "@/components/shared/text/BigTitle.vue";
import ButtonMain from "@/components/shared/buttons/ButtonMain.vue";

export default {
  name: "ErrorPage",
  components: {ButtonMain, BigTitle},
  data() {
    return {
      mainTitle: 'Упс! Произошла ошибка!',
      btnText: 'Выйти'
    }
  }
}
</script>

<style scoped>
 .error-page-container {
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
   width: 100%;
   height: 100%;
   row-gap: 24px;
 }
</style>